import {WorkspaceAggregation} from "@/model/workspace";
import React from "react";
import moment from "moment/moment";


type WorkspaceMemberViewProps = {
    workspace: WorkspaceAggregation
}

const WorkspaceMemberView: React.FC<WorkspaceMemberViewProps> = (props) => {
    const {workspace} = props;
    // const {data: memberSummaryResponse} = useMember(workspace._id);
    return (
        <div className="p-5 space-y-3 text-[16px]">
            <div className="font-bold">고객 정보</div>
            <div className="px-2 space-y-3">
                <div>고객 이름 : {workspace.user?.fullName}</div>
                <div>고객 이메일 : {workspace.user?.email}</div>
                <div>가입일 : {moment.utc(workspace.user?.createdAt).local().format("YYYY-MM-DD HH:mm:ss")}</div>
                <div>최근 접속일 : {moment.utc(workspace.user?.accessTime).local().format("YYYY-MM-DD HH:mm:ss")}</div>
                {workspace.user?.deleted && workspace.user?.deletedAt &&
                    <div>계정 탈퇴일 : {moment.utc(workspace.user.deletedAt).local().format("YYYY-MM-DD HH:mm:ss")}</div>
                }
            </div>
        </div>
        // <div className="p-5">
        //     {memberSummaryResponse?.memberSummary.map((member) => {
        //         return (
        //                 <div className="py-3">
        //                     <div className="text-2xl">
        //                         {member.role.name}
        //                     </div>
        //                     이름 : {member.user.fullName} <br/>
        //                     이메일 : {member.user.email}
        //                 </div>
        //         )
        //     })}
        // </div>
    )
}

export default WorkspaceMemberView;